import i18next from 'i18next';

i18next.addResources('es_CL', 'CheckoutPersonalDataForm', {
  title: 'Complete su perfil',
  name: 'Tu nombre',
  email: 'Tu correo',
  phone: 'Tu teléfono',
  login: 'Iniciar sesión',
  register: 'Regístrate',
  idNumber: 'Rut (opcional)'
});

i18next.addResources('es_ES', 'CheckoutPersonalDataForm', {
  title: 'Complete su perfil',
  email: 'Tu email',
  register: 'Regístrate'
});

i18next.addResources('pt_PT', 'CheckoutPersonalDataForm', {
  title: 'Complete seu perfil',
  name: 'O teu nome',
  email: 'O teu email',
  phone: 'O teu telefone',
  login: 'Inicia Sessão',
  register: 'Regista-Te'
});

i18next.addResources('es_CR', 'CheckoutPersonalDataForm', {
  title: 'Completá tu perfil'
});
